import { render, staticRenderFns } from "./Review_person.vue?vue&type=template&id=17fb09f6&scoped=true"
import script from "./Review_person.vue?vue&type=script&lang=js"
export * from "./Review_person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fb09f6",
  null
  
)

export default component.exports